import React, { Fragment } from "react";
import DataTable from "react-data-table-component";
import "react-toastify/dist/ReactToastify.css";
import DataTableExtensions from "react-data-table-component-extensions";
import placeholder from "../../assets/images/fashion/product/12.jpg";
const UpgradeItems = ({ myData, myClass }) => {
  const columnDefs = [
    {
      name: "User Items Image",
      cell: (row) => (
        <ItemsImage
          image={row.result ? row?.result?.fromItem?.bannerImage : placeholder}
        />
      ),
    },
    {
      name: "User Items Name",
      selector: (row) => row?.result?.fromItem?.name,
      sortable: true,
    },
    {
      name: "user Items Price",
      selector: (row) => `€ ${row?.result?.fromItem?.price}`,
      sortable: true,
    },
    {
      name: "Admin Items Image",
      cell: (row) => (
        <ItemsImage
          image={row.result ? row?.result?.toItem?.bannerImage : placeholder}
        />
      ),
    },
    {
      name: "Admin Items Name",
      selector: (row) => row?.result?.toItem?.name,
      sortable: true,
    },
    {
      name: "Admin Items Price",
      selector: (row) => `€ ${row?.result?.toItem?.price}`,
      sortable: true,
    },
    {
      name: "Win Status",
      selector: (row) => (row?.status === "success" ? "Win" : "Lose"),
      sortable: true,
    },
  ];
  return (
    <div>
      <Fragment>
        <DataTableExtensions
          columns={columnDefs}
          data={myData}
          print={false}
          export={false}>
          <DataTable
            data={myData}
            columns={columnDefs}
            className={myClass}
            pagination
            striped={true}
            center={true}
          />
        </DataTableExtensions>
      </Fragment>
    </div>
  );
};
const ItemsImage = ({ image }) => {
  return (
    <div className="profile-image">
      <img src={image} alt="logo" />
    </div>
  );
};
export default UpgradeItems;
